import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSkip(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M18 19a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v12a1 1 0 0 1-1 1Z" fill="currentColor" />
      <path
        d="M14 12a1 1 0 0 1-.382.786l-7 5.5A1 1 0 0 1 5 17.5v-11a1 1 0 0 1 1.618-.786l7 5.5A1 1 0 0 1 14 12ZM7 8.557v6.886L11.381 12 7 8.557Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
